import CronJobsList from './CronJobsList';

const cronJobsResources = {
    list: CronJobsList,

};

export default cronJobsResources;